import { generateApiUrl } from "@/shared/utils";
import { getUserInfo } from "@/services";
/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";

export const getUser = async (code) => {
  try {
    const url = generateApiUrl(["profile", "v2", "user_id"], [code]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const permissions = pathOr([], ["data", "permissions"], response);
    const name = pathOr(null, ["person", "name"], data);
    const family = pathOr(null, ["person", "family"], data);
    return {
      full_name: `${name} ${family}`,
      username: pathOr(null, ["username"], data),
      mobile: pathOr(null, ["mobile"], data),
      email: pathOr(null, ["email"], data),
      twoStep: pathOr(false, ["two_step_verification"], data),
      loginNotify: pathOr(false, ["login_notify"], data),
      isEnable: pathOr(false, ["is_enable"], data),
      permissions,
    };
  } catch (error) {
    throw error;
  }
};
export const editUser = async (
  code,
  mobile,
  email,
  expireAt,
  twoStep,
  loginNotify
) => {
  try {
    const url = generateApiUrl(["profile", "userIdChangeInfo"], [code]);
    const payload = {
      mobile,
      email,
      expire_at: expireAt,
      two_step_verification: twoStep,
      login_notify: loginNotify,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const getProfileUser = async () => {
  try {
    const url = generateApiUrl(["globalServices", "mainUserInfo"]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const permissions = pathOr([], ["data", "permissions"], response);
    return {
      code: pathOr(null, ["code"], data),
      username: pathOr(null, ["username"], data),
      mobile: pathOr(null, ["mobile"], data),
      email: pathOr(null, ["email"], data),
      permissions,
    };
  } catch (error) {
    throw error;
  }
};
export const changeUserPassword = async (oldPassword, newPassword) => {
  try {
    const url = generateApiUrl(["profile", "userChangePass"]);
    const payload = {
      current_password: oldPassword,
      password: newPassword,
      password_confirmation: newPassword,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const changeUserInfo = async (username, email) => {
  try {
    const url = generateApiUrl(["profile", "userChangeInfo"]);
    const payload = { username, email };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const changeUserMobile = async (mobile, code, controlCode) => {
  try {
    const url = generateApiUrl(["profile", "userChangeMobile"]);
    const payload = {
      mobile,
      two_step_code: code,
      control_code: controlCode,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    await getUserInfo();

    return { message };
  } catch (error) {
    throw error;
  }
};
export const changeUserIsEnable = async (userCode, isEnable) => {
  try {
    const url = generateApiUrl(["profile", "user_id"], [userCode]);
    const payload = {
      is_enable: isEnable,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
export const changeUserPassByAdmin = async ({
  code,
  username,
  password,
  sendSms,
}) => {
  try {
    const url = generateApiUrl(["profile", "change_user_pass"], [code]);
    const payload = {
      username,
      password,
      password_confirmation: password,
      send_sms: sendSms,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
